<template>
  <UnavailableProductNew v-if="newUnavailablePage" />
  <UnavailableProductOld v-else />
</template>

<script setup lang="ts">
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import UnavailableProductNew from '~/components/unavailable/UnavailableProductNew.vue';
import UnavailableProductOld from '~/components/unavailable/UnavailableProductOld.vue';

const {
  killswitches: { newUnavailablePage },
} = useKillswitches();
</script>
